module.exports = __webpack_public_path__ + "img/SB.a89dfd25.png";